/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { createSlice } from '@reduxjs/toolkit';

export const FlowType = {
  BOOKING: 'bookings',
  CART: 'cart',
};

export const FLOW_STORAGE_KEY = "sb_active_flow";

const initialState = {
  activeFlow: sessionStorage.getItem(FLOW_STORAGE_KEY) || null,
};

const flowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setFlow: (state, action) => {
      state.activeFlow = action.payload;
    },
    resetFlow: (state) => {
      state.activeFlow = null;
    },
  },
});

export const { setFlow, resetFlow } = flowSlice.actions;
export default flowSlice.reducer;